import React, { Component } from "react";
import { Link } from "react-router-dom";
import Loader from "../component/loader";
import MainLayout from "../mainLayout";
import TextField from "../component/TextField";

import CopyIcon from "../icons/copyicon";
import UploadFile from "../component/UploadFile";
import FpgMinusIcon from "../icons/fpgminusicon";
import FpgPlusIcon from "../icons/fpgplusicon";
import TextEditor from "../component/TextEditor";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
//Service import
import service from "../services";
import _ from "lodash";
//Validation import
import SimpleReactValidator from "simple-react-validator";
import { Editor } from "react-draft-wysiwyg";
import { EditorState, convertToRaw, ContentState } from "draft-js";
import { convertFromRaw } from "draft-js";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import draftToHtml from "draftjs-to-html";
import htmlToDraft from "html-to-draftjs";
import moment from "moment-timezone";

let sub;
const content = {
  entityMap: {},
  blocks: [
    {
      key: "637gr",
      text: "Initialized from content state.",
      type: "unstyled",
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
  ],
};

// fake data generator
const getItems = (count) =>
  Array.from({ length: count }, (v, k) => k).map((k) => ({
    id: `item-${k}`,
    content: `item ${k}`,
  }));

// a little function to help us with reordering the result
const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
};
export default class FestivalHelp extends Component {
  constructor(props) {
    super(props);
    const contentState = convertFromRaw(content);
    this.state = {
      getFestivalHelp: [],
      questionArray: [
        {
          _id: Math.random(),
          question: "",
          answer: "",
        },
      ],
      loaderFlag: false,
      imagePreloader: true,
      editorState: EditorState.createEmpty(),
      subtitle: EditorState.createEmpty(),
      contentState,
      data: [
        {
          label: "Festival Help Page",
          Content: "",
        },
      ],
    };
    this.validator = new SimpleReactValidator({ autoForceUpdate: this });
    this.apiserve = new service();
  }

  componentDidMount = async () => {
    this.getAllFestivalHelp();
    this.getFestivalHelpEvent();
    this.setState({
      loaderFlag: true,
    });
  };

  componentWillUnmount = () => {
    sub.unsubscribe();
  };

  getFestivalHelpEvent = () => {
    var self = this;
    sub = this.apiserve.getevent().subscribe((response) => {
      switch (response.event) {
        case "help|question|getList":
          if (!response.error) {
            var questionArray =
              response.data &&
              response.data.docs &&
              response.data.docs[0] &&
              response.data.docs[0].questionArray.map((image) => {
                var question = {
                  _id: Math.random(),
                  question: image.question,
                  answer: image.answer,
                };
                return question;
              });
            if (this.state.subtitle) {
              const blocksFromHtml = htmlToDraft(
                (response &&
                  response.data &&
                  response.data.docs[0] &&
                  response.data.docs[0].subtitle) ||
                  ""
              );
              const { contentBlocks, entityMap } = blocksFromHtml;
              const contentState = ContentState.createFromBlockArray(
                contentBlocks,
                entityMap
              );
              const subtitle = EditorState.createWithContent(contentState);
              this.setState({
                subtitle: subtitle,
              });
            }
            if (questionArray) {
              const docs = questionArray.map((e) => {
                const blocksFromHtml = htmlToDraft(e.answer);
                const { contentBlocks, entityMap } = blocksFromHtml;
                const contentState = ContentState.createFromBlockArray(
                  contentBlocks,
                  entityMap
                );
                e.answer = EditorState.createWithContent(contentState);
                return e;
              });
            }
            if (questionArray !== undefined) {
              this.setState(
                {
                  questionArray:
                    questionArray !== undefined
                      ? questionArray
                      : self.state.questionArray,
                  getFestivalHelp: response.data,
                  title:
                    response &&
                    response.data &&
                    response.data.docs[0] &&
                    response.data.docs[0].title,
                  error: response.data.error,
                },
                () => {
                  this.setState({
                    loaderFlag: false,
                  });
                }
              );
            } else {
              this.setState(
                {
                  questionArray: this.state.questionArray,
                },
                () => {
                  this.setState({
                    loaderFlag: false,
                  });
                }
              );
            }
          }

          break;
        case "help|question|create":
          if (response.error === true) {
            const blocksFromHtml = htmlToDraft(response.data.answer);
            const { contentBlocks, entityMap } = blocksFromHtml;
            const contentState = ContentState.createFromBlockArray(
              contentBlocks,
              entityMap
            );
            const answer = answer.createWithContent(contentState);
            this.setState({
              loaderFlag: false,
              errorMsg: true,
              answer: answer,
              errorMsgShow: response.data.error,
            });
          } else {
            this.apiserve.success("Festival Help created successful.");
            this.setState({ loaderFlag: false });
            this.getAllFestivalHelp()
          }
          break;
        case "help|question|getLastUpdated":
          this.setState({
            getLastUpdated: response.data,
          });
          break;
        case "help|question|exploreList":
          break;
      }
    });
  };

  getAllFestivalHelp = () => {
    this.apiserve.sendevent("help|question|getList", {});
    this.apiserve.sendevent("help|question|getLastUpdated", { type: 1 });
  };

  //FestivalHelp Push
  addFestivalHelpFiled = (item) => {
    var newData = {
      _id: Math.random(),
      question: "",
      answer: EditorState.createEmpty(),
    };
    var oldData = this.state.questionArray;
    oldData.push(newData);

    this.setState({
      questionArray: oldData,
    });
  };

  //FestivalHelp Remove
  removeFestivalHelpFiled = (i) => {
    var filteredFestivalHelp = this.state.questionArray.filter(
      (_) => _._id !== i
    );
    this.setState({
      questionArray: filteredFestivalHelp,
    });
  };

  onChangeFestivalHelp = (e, id) => {
    const { name, value } = e.target;
    this.state.questionArray.forEach((dataList) => {
      if (dataList._id === id) dataList[name] = value;
    });
    this.setState({});
  };

  submitFn = async (e) => {
    e.preventDefault();
    if (this.validator.allValid()) {
      this.setState({ loaderFlag: true });
      var questionArray = this.state.questionArray.map((element) => {
        const name = element.answer
          ? convertToRaw(element.answer.getCurrentContent())
          : "";
        const markup = draftToHtml(name);
        var List = {
          question: element.question,
          answer: markup.trim(),
        };

        return List;
      });
      const subtitle = convertToRaw(this.state.subtitle.getCurrentContent());
      const markup = draftToHtml(subtitle);
      this.apiserve.sendevent("help|question|create", {
        questionArray: questionArray,
        title: this.state.title,
        subtitle: markup.trim(),
      });
    } else {
      this.validator.showMessages();
      this.forceUpdate();
    }
  };

  onEditorStateChange = (answer, id) => {
    this.state.questionArray.forEach((dataList) => {
      if (dataList._id === id) {
        dataList.answer = answer;
      }
    });

    this.setState({});
  };

  onEditorState = (subtitle) => {
    this.setState({
      subtitle,
    });
  };

  validateModel = () => {
    this.setState({
      errorMsg: false,
    });
  };
  handleInput = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  cancelBTN = (e) => {
    e.preventDefault();
    window.location.reload();
    // this.props.history.push({pathaname: '/ticketing'})
  };

  onDragEnd = (result) => {
    if (!result.destination) {
      return;
    }
    const { destination, source } = result;
    const oldIndex = source.index;
    const newIndex = destination.index;
    const arr = [...this.state.questionArray];
    if (newIndex >= arr.length) {
      var k = newIndex - arr.length + 1;
      while (k--) {
        arr.push(undefined);
      }
    }
    arr.splice(newIndex, 0, arr.splice(oldIndex, 1)[0]);
    const updateArr = [];
    arr.forEach(({ _id }, i) => {
      updateArr.push({
        categoryId: _id,
        sortIndex: i + 1,
      });
    });
    this.setState({ isDraggable: true });
    // const data = { order: updateArr };
    this.apiserve.sendevent("help|question|exploreList", Object.assign({},updateArr));
    this.setState({ questionArray: arr });
  };
  render() {
    const { getLastUpdated, questionArray } = this.state;
    var updateAt = new Date(getLastUpdated && getLastUpdated.updatedAt);
    var hour = moment.tz(updateAt, 'US/Mountain').format("h");
    var minutes = moment.tz(updateAt, 'US/Mountain').format("mm");
    var state = moment.tz(updateAt, 'US/Mountain').format("A");
    var updatedBy = getLastUpdated && getLastUpdated.updatedBy;
    return (
      <React.Fragment>
        <div className="right_side_wrapper artistView_wrapper">
          <ul className="fpg_admin_tab disp_flex">
            {this.state.data &&
              this.state.data.map((list, index) => {
                return (
                  <li className="active">
                    <p className="uppercase text_left">
                      <div>{list.label}</div>
                    </p>
                  </li>
                );
              })}
          </ul>
          <div className="back_date d_flex d_flex_align_center d_flex_justify_spacebt">
            <p></p>
            {this.state.getLastUpdated &&
            this.state.getLastUpdated.updatedAt === undefined ? (
              ""
            ) : (
              <p className="update_date">
                Last Update: {hour}:{minutes} {state} -{" "}
                {moment.tz(updateAt, 'US/Mountain').format("MM/DD/YYYY")} Last Updated By:{" "}
                {updatedBy && updatedBy.fname} {updatedBy && updatedBy.lname}
              </p>
            )}
          </div>

          <div className="fpg_tabcontent about_sundance">
            <form>
              <div className="field_row horizontal_field">
                <TextField
                  type="text"
                  label="Header Title"
                  name="title"
                  value={this.state.title}
                  onChange={this.handleInput}
                />
              </div>
              <div className="field_heading field_row horizontal_field mb_25">
                <div className="field_row_inner">
                  <label className="fest_field_title">Paragraph 1</label>
                  <div className="field_input relative editor_wrapper">
                    {/* <textarea value={this.state.subtitle}></textarea> */}
                    <TextEditor
                      value={this.state.subtitle}
                      name="subtitle"
                      editorState={this.state.subtitle}
                      onEditorStateChange={(e) => this.onEditorState(e)}
                    />
                  </div>
                </div>
              </div>
              {/* <DragDropContext>
                <Droppable droppableId="droppable">
                  {(provided, snapshot) => (
                    <ul {...provided.droppableProps} ref={provided.innerRef}>
                      <Draggable>
                        {(provided, snapshot) => (
                          <li ref={provided.innerRef}
                                 {...provided.draggableProps}
                                 {...provided.dragHandleProps}></li>
                        )}
                        <p>Hello</p>
                      </Draggable>
                    </ul>
                  )}
                </Droppable>
              </DragDropContext> */}
              <DragDropContext onDragEnd={this.onDragEnd}>
                <Droppable droppableId="droppable">
                  {(provided, snapshot) => (
                    <ul {...provided.droppableProps} ref={provided.innerRef}>
              {questionArray &&
                questionArray?.map((item, index) => (
                  // for (let i = 0; i < questionArray.length; i++) {
                  // }
                  <Draggable
                    key={item._id}
                    draggableId={String(item._id)}
                    index={index}
                  >
                    {(provided, snapshot) => (
                      <li
                        className="pointer d_flex d_flex_align_center"
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                      >
                  <div className="section_box_wrapper">
                    <div className="d_flex d_flex_align_center">
                      <>
                        <div className="section_box help_box">
                          <div className="header">
                            <p>Section {index + 1}</p>
                          </div>

                          <div className="section_content">
                            <div className="d_flex">
                              <div className="section_fields">
                                <div className="field_row horizontal_field">
                                  <TextField
                                    type="text"
                                    label="Question"
                                    name="question"
                                    value={item.question}
                                    onChange={(e) =>
                                      this.onChangeFestivalHelp(e, item._id)
                                    }
                                  />
                                </div>
                                <div className="field_heading field_row horizontal_field">
                                  <div className="field_row_inner">
                                    <label className="fest_field_title">
                                      Paragraph
                                    </label>
                                    <div className="field_input relative">
                                      {/* <div className="heading_bg"> </div> */}
                                      <div className="bg_white">
                                        <TextEditor
                                          height={250}
                                          value={item.answer || ""}
                                          name="answer"
                                          editorState={item.answer || ""}
                                          onEditorStateChange={(e) =>
                                            this.onEditorStateChange(
                                              e,
                                              item._id
                                            )
                                          }
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="section_actions">
                          {index === 0 ? (
                            <>
                            <span
                              className="pointer"
                              onClick={() =>
                                this.addFestivalHelpFiled(item, index)
                              }
                            >
                              <FpgPlusIcon
                                width="20"
                                height="20"
                                color="#4F4F4F"
                                stroke="#fff"
                              />
                            </span>
                            <span></span>
                            </>
                          ) : (
                            <>
                              <span
                                className="pointer"
                                onClick={() =>
                                  this.addFestivalHelpFiled(item, index)
                                }
                              >
                                <FpgPlusIcon
                                  width="20"
                                  height="20"
                                  color="#4F4F4F"
                                  stroke="#fff"
                                />
                              </span>
                              <span
                                className="pointer"
                                onClick={() =>
                                  this.removeFestivalHelpFiled(item._id)
                                }
                              >
                                <FpgMinusIcon
                                  width="20"
                                  height="20"
                                  color="#4F4F4F"
                                  stroke="#fff"
                                />
                              </span>
                            </>
                          )}
                        </div>
                      </>
                    </div>
                  </div>
                   </li>
                  )}
                  </Draggable>
                ))}
              </ul> 
               )} 
               </Droppable>
              </DragDropContext>

              <div className="text_center field_row w_100 buttons_outer mb_0">
                <button className="uppercase" onClick={this.cancelBTN}>
                  CANCEL
                </button>
                <button
                  className="uppercase active"
                  type="button"
                  onClick={(e) => this.submitFn(e)}
                >
                  SAVE
                </button>
              </div>
            </form>
          </div>
        </div>
        <div className={`user_popup ${this.state.errorMsg ? "active" : ""}`}>
          <span className="popup_overlay"></span>
          <div className="sundance_popup_detail box_shadow approve_success_popup bg_white">
            <div className="approve_popup_header text_center relative">
              <p>{this.state.errorMsgShow}</p>
            </div>
            <div className="content">
              <div className="field_row text_center">
                <button
                  className="small_btn active"
                  onClick={this.validateModel}
                >
                  OK
                </button>
              </div>
            </div>
          </div>
        </div>
        {this.state.loaderFlag ? <Loader /> : ""}
      </React.Fragment>
    );
  }
}
